import {Route, Switch} from 'react-router-dom';

import NotFound from 'pages/NotFound';

import {STAFF_PATH} from 'types/Business';

import Items from './Items';
import StaffForm from './StaffForm';

const Staff = () => {
  return (
    <Switch>
      <Route exact path={`${STAFF_PATH}/staff`} component={Items} />
      <Route exact path={`${STAFF_PATH}/staff/add`} component={StaffForm} />
      <Route
        exact
        path={`${STAFF_PATH}/staff/:staff_id`}
        component={StaffForm}
      />
      <Route component={NotFound} />
    </Switch>
  );
};

export default Staff;
